import { render, staticRenderFns } from "./guaranteeFace.vue?vue&type=template&id=4c6a3d9f&scoped=true"
import script from "./guaranteeFace.vue?vue&type=script&lang=ts"
export * from "./guaranteeFace.vue?vue&type=script&lang=ts"
import style0 from "./guaranteeFace.vue?vue&type=style&index=0&id=4c6a3d9f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6a3d9f",
  null
  
)

export default component.exports